import { render } from "./ImpersonateBar.vue?vue&type=template&id=c520e44c&scoped=true&ts=true"
import script from "./ImpersonateBar.vue?vue&type=script&lang=ts"
export * from "./ImpersonateBar.vue?vue&type=script&lang=ts"

import "./ImpersonateBar.vue?vue&type=style&index=0&id=c520e44c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.27_typescript@5.9.3__webpack@5.105.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c520e44c"]])

export default __exports__